import styled from "styled-components";

// mainPage를 제외한 나머지 Page Wrapper
const OtherWrapper = styled.main`
    height: calc(100vh - 5.5rem - 40.67px);
    padding: 20px;
`

export default OtherWrapper